import { useCallback, useState } from 'react';
import { UsuarioGet, UsuarioAdd, UsuarioUpdate, UsuarioDelete } from '../service/usuarios';

export default function useUsers() {
    // Estado de carga del listado: los servicios Add/Update/Delete ya movían
    // State.loading, pero el GET no, y las tablas no tenían cómo saber que
    // todavía estaban esperando datos.
    const [cargando, setCargando] = useState(false);

    const [Usuarios, setUsuarios] = useState([]);
    const [State, setState] = useState({ loading: false, error: false, message: '', success: false });

    const UsuariosGetService = useCallback((token) => {
        setCargando(true);
        UsuarioGet(token).then(response => {
            setUsuarios(response)
        }).finally(() => setCargando(false))
    }, []);
    /*
     * Agregar usuario
     */
    const UsuariosAddService = useCallback((
        data, token
    ) => {
        setState({
            loading: true,
            error: false,
            message: '',
            success: false
        });
        UsuarioAdd(
            data, token
        ).then(response => {
            let errores = response.errors;
            if (errores !== undefined) {
                let primerError = Object.values(errores)[0];
                setState({
                    loading: false,
                    error: true,
                    message: primerError ? primerError[0] : 'Datos inválidos',
                    success: false
                })
            } else {
                if (response.guardado === true) {
                    setState({
                        loading: false,
                        error: false,
                        message: 'Usuario registrado con exito',
                        success: true
                    })
                } else {
                    setState({
                        loading: false,
                        error: true,
                        message: 'Error al registrar usuario',
                        success: false
                    })
                }
            }
        }).catch(() => {
            setState({ loading: false, error: true, message: 'No se pudo conectar con el servidor', success: false })
        })
    }, [])

    /*
     * Actualizar usuario
     */
    const UsuariosUpdateService = useCallback((
        data, token
    ) => {
        setState({
            loading: true,
            error: false,
            message: '',
            success: false
        });
        UsuarioUpdate(
            data, token
        ).then(response => {
            let errores = response.errors;
            if (errores !== undefined) {
                let primerError = Object.values(errores)[0];
                setState({
                    loading: false,
                    error: true,
                    message: primerError ? primerError[0] : 'Datos inválidos',
                    success: false
                })
            } else {
                if (response.guardado === true) {
                    setState({
                        loading: false,
                        error: false,
                        message: 'Usuario actualizado con exito',
                        success: true
                    })
                } else {
                    setState({
                        loading: false,
                        error: true,
                        message: 'Error al actualizar usuario',
                        success: false
                    })
                }
            }
        }).catch(() => {
            setState({ loading: false, error: true, message: 'No se pudo conectar con el servidor', success: false })
        })
    }, [])
    /*
     * Eliminar usuario
     */
    const UsuariosDeleteService = useCallback((
        data, token
    ) => {
        setState({
            loading: true,
            error: false,
            message: '',
            success: false
        });
        UsuarioDelete(
            data, token
        ).then(response => {
            if (response.guardado === true) {
                setState({
                    loading: false,
                    error: false,
                    message: 'Usuario eliminado con exito',
                    success: true
                })
            } else {
                setState({
                    loading: false,
                    error: true,
                    message: 'Error al eliminar usuario',
                    success: false
                })
            }
        }).catch(() => {
            setState({ loading: false, error: true, message: 'No se pudo conectar con el servidor', success: false })
        })
    }, [])

    return {
        loading: State.loading || cargando,
        error: State.error,
        message: State.message,
        success: State.success,
        Usuarios,
        UsuariosGetService,
        UsuariosAddService,
        UsuariosUpdateService,
        UsuariosDeleteService
    }



}